import React from 'react';

/** @see android/TipPay Emp/app/src/main/res/drawable/ic_arrow_back.xml */
export function IcArrowBack({ className = '' }) {
  return (
    <svg className={className} width={24} height={24} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M20,11H7.83l5.59,-5.59L12,4l-8,8 8,8 1.41,-1.41L7.83,13H20v-2z" />
    </svg>
  );
}

/** @see android/TipPay Emp/app/src/main/res/drawable/ic_empty_list.xml */
export function IcEmptyListIllustration({ className = '' }) {
  return (
    <svg
      className={className}
      width={80}
      height={80}
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="m24,20c0,-1.105 0.895,-2 2,-2h25c1.105,0 2,0.895 2,2s-0.895,2 -2,2h-25c-1.105,0 -2,-0.895 -2,-2z"
      />
      <path
        fill="currentColor"
        d="m24,32c0,-1.105 0.895,-2 2,-2h25c1.105,0 2,0.895 2,2s-0.895,2 -2,2h-25c-1.105,0 -2,-0.895 -2,-2z"
      />
      <path
        fill="currentColor"
        d="m24,44c0,-1.105 0.895,-2 2,-2h25c1.105,0 2,0.895 2,2s-0.895,2 -2,2h-25c-1.105,0 -2,-0.895 -2,-2z"
      />
      <path
        fill="currentColor"
        d="m15.414,16.586c-0.781,-0.781 -2.047,-0.781 -2.828,0 -0.781,0.781 -0.781,2.047 0,2.828l0.586,0.586 -0.586,0.586c-0.781,0.781 -0.781,2.047 0,2.828 0.781,0.781 2.047,0.781 2.828,0l0.586,-0.586 0.586,0.586c0.781,0.781 2.047,0.781 2.828,0 0.781,-0.781 0.781,-2.047 0,-2.828l-0.586,-0.586 0.586,-0.586c0.781,-0.781 0.781,-2.047 0,-2.828 -0.781,-0.781 -2.047,-0.781 -2.828,0l-0.586,0.586z"
      />
      <path
        fill="currentColor"
        d="m12.586,28.586c0.781,-0.781 2.047,-0.781 2.828,0l0.586,0.586 0.586,-0.586c0.781,-0.781 2.047,-0.781 2.828,0 0.781,0.781 0.781,2.047 0,2.828l-0.586,0.586 0.586,0.586c0.781,0.781 0.781,2.047 0,2.828 -0.781,0.781 -2.047,0.781 -2.828,0l-0.586,-0.586 -0.586,0.586c-0.781,0.781 -2.047,0.781 -2.828,0 -0.781,-0.781 -0.781,-2.047 0,-2.828l0.586,-0.586 -0.586,-0.586c-0.781,-0.781 -0.781,-2.047 0,-2.828z"
      />
      <path
        fill="currentColor"
        d="m15.414,40.586c-0.781,-0.781 -2.047,-0.781 -2.828,0 -0.781,0.781 -0.781,2.047 0,2.828l0.586,0.586 -0.586,0.586c-0.781,0.781 -0.781,2.047 0,2.828 0.781,0.781 2.047,0.781 2.828,0l0.586,-0.586 0.586,0.586c0.781,0.781 2.047,0.781 2.828,0 0.781,-0.781 0.781,-2.047 0,-2.828l-0.586,-0.586 0.586,-0.586c0.781,-0.781 0.781,-2.047 0,-2.828 -0.781,-0.781 -2.047,-0.781 -2.828,0l-0.586,0.586z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m2,20c0,-9.941 8.059,-18 18,-18h24c9.941,0 18,8.059 18,18v24c0,9.941 -8.059,18 -18,18h-24c-9.941,0 -18,-8.059 -18,-18zM20,6c-7.732,0 -14,6.268 -14,14v24c0,7.732 6.268,14 14,14h24c7.732,0 14,-6.268 14,-14v-24c0,-7.732 -6.268,-14 -14,-14z"
      />
    </svg>
  );
}
